module.exports = "./img/0875fc62b1c0aaf6565034e9e64f3348.jpg";